'use es6';

import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'quartz-routing/react-router';
import { Set as ImmutableSet } from 'immutable';
import { parse, stringify } from 'hub-http/helpers/params';
export const RESULTS_URL_FRAGMENT = '/results';

/**
 * Input element types (real or simulated) that can be deselected,
 * e.g. a checkbox being unchecked. This could also include 'radio' but we're
 * not using those anywhere at the moment.
 *
 * This is necessary because all input elements have a "checked" property
 * which defaults to false, including text input / search fields.
 */

export const parseAllParams = search => parse(search.slice(1));
export const parseValue = (key, search = window.location.search) => {
  const value = parseAllParams(search)[key];
  return value ? Array.isArray(value) ? value : [value] : [];
};

/**
 * Get a new value (array) for the param.
 */
export const getNewValue = (isDeselected, value, replace, inputVal) => (isDeselected ? replace ? ImmutableSet() : ImmutableSet(value).delete(inputVal) : replace ? ImmutableSet([inputVal]) : ImmutableSet(value).add(inputVal)).toArray();

/**
 * Custom hook to get and set a url param.
 *
 * @param {string} key Param name
 * @param {boolean} [clearCatalogFilers=false] Optional flag to remove catalog filters
 * @returns {[string[], function]} Array with [valueArr, setValue]
 */
export const useSearchParam = (key,
// eslint-disable-next-line @typescript-eslint/no-unused-vars
clearCatalogFilers = false, goToResults = false) => {
  const history = useHistory();
  const location = useLocation();
  const value = useMemo(() => parseValue(key, location.search), [key, location.search]);
  const setValue = useCallback(newValue => {
    const allParams = parseAllParams(location.search);
    history.push(Object.assign({}, location, {
      pathname: goToResults ? RESULTS_URL_FRAGMENT : location.pathname,
      search: stringify(Object.assign(allParams, {
        [key]: newValue
      }))
    }));
  }, [goToResults, history, key, location]);
  return [value, setValue];
};
export const useParentAppName = () => {
  const location = useLocation();
  return useMemo(() => parseValue('parentAppName', location.search)[0], [location.search]);
};